export const enterpriseChartPalette = [
  "#2563eb",
  "#4f46e5",
  "#10b981",
  "#f59e0b",
  "#ef4444",
  "#0ea5e9",
  "#7c3aed",
  "#64748b",
];

// ✅ Ab ye function hai, jo mode ke hisaab se sahi colors deta hai
export const getChartTheme = (isDark = false) => ({
  colors: enterpriseChartPalette,
  card: {
    background: isDark
      ? "linear-gradient(180deg, #1e2536 0%, #171d2c 100%)"
      : "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
    border: isDark ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(15, 23, 42, 0.08)",
    radius: 16,
    shadow: isDark ? "0 10px 30px rgba(0,0,0,0.4)" : "0 10px 30px rgba(15, 23, 42, 0.08)",
  },
  grid: {
    stroke: isDark ? "rgba(255,255,255,0.14)" : "#e2e8f0",
    strokeDasharray: "4 4",
  },
  axis: {
    tick: {
      fill: isDark ? "#cbd5e1" : "#64748b",   // ← ye hi tumhari axis values ka color hai
      fontSize: 12,
      fontWeight: 500,
    },
    label: {
      fill: isDark ? "#e2e8f0" : "#475569",
      fontSize: 12,
      fontWeight: 600,
    },
  },
  tooltip: {
    backgroundColor: isDark ? "#1e2536" : "#ffffff",
    border: isDark ? "1px solid rgba(255,255,255,0.12)" : "1px solid #e2e8f0",
    color: isDark ? "#f8fafc" : "#0f172a",
    borderRadius: 12,
    boxShadow: isDark ? "0 12px 30px rgba(0,0,0,0.5)" : "0 12px 30px rgba(15, 23, 42, 0.12)",
  },
  legend: {
    wrapperStyle: {
      paddingTop: 12,
      color: isDark ? "#e2e8f0" : "#334155",
    },
    iconType: "circle",
  },
});

// ✅ Backward-compatible: jahan sirf .colors chahiye (jaise CustomChartsWidget.js, CustomChartsPage.js), wo waise hi chalega
export const enterpriseChartTheme = getChartTheme(false);

export const formatChartValue = (value) => {
  if (typeof value === "number") {
    if (Math.abs(value) >= 1000) {
      return new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 1,
        notation: "compact",
      }).format(value);
    }
    return new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 2,
    }).format(value);
  }

  if (value instanceof Date) {
    return value.toLocaleDateString();
  }

  return value;
};

export const getChartColor = (index, fallback = enterpriseChartPalette[0]) => {
  return enterpriseChartPalette[index % enterpriseChartPalette.length] || fallback;
};